import Search from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { ChangeEvent, memo, useCallback, KeyboardEvent, useState } from "react";

interface ISearchBoxProps {
    onEnter(query?: string): void;
}

export const SearchBox = memo((props: ISearchBoxProps) => {
    const [query, setQuery] = useState("");

    const onEnterCallback = props.onEnter;
    const onEnter = useCallback((e: KeyboardEvent<HTMLDivElement>): void => {
        if (e.key === "Enter") {
            onEnterCallback(query);
        }
    }, [query, onEnterCallback]);
    const onSearchClicked = useCallback(() => {
        onEnterCallback(query);
    }, [query, onEnterCallback]);

    const onChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>): void => {
        setQuery(e.target.value);
    }, []);

    return (
        <Grid container alignItems="center" rowSpacing={{ xs: 1 }} columnSpacing={2}>
            <Grid item xs={12} sm={10}>
                <TextField fullWidth InputProps={{
                    startAdornment: <InputAdornment position="start">
                        <IconButton
                            aria-label="search"
                            edge="start"
                        ></IconButton><Search /></InputAdornment>,
                }} label="Search for ETFs" value={query} type="search" onKeyDown={onEnter} onChange={onChange} />
            </Grid>
            <Grid item xs={12} sm={2}>
                <Button onClick={onSearchClicked} className="CinnamonButton" sx={{ paddingTop: 1.5, paddingBottom: 1.5, width: "100%", height: "100%", textTransform: "none" }} variant="outlined">Search</Button>
            </Grid>
        </Grid>
    );
});

export default SearchBox;